import React from 'react';

const BuilderContext = React.createContext(null);

export default BuilderContext;
